{
  "dismissedMessage": "Solicitud rechazada para \"{{tailNumber}}\"",
  "dismissError": "No se pudo descartar la solicitud. Intenta de nuevo.",
  "emptyState": "No hay solicitudes de matrícula pendientes",
  "unknown": "Desconoc.",
  "headers": {
    "tailNumber": "Matrícula",
    "fboName": "Nombre FBO",
    "requestedBy": "Solicitado por",
    "requestedAt": "Solicitado",
    "actions": "Acciones"
  },
  "dismissTooltip": "Descartar esta solicitud"
}
